import { UserIdSchema as a } from "@hprofits/shared";
import { z as e } from "zod";
const n = e.object({
  id: a,
  email: e.string(),
  balance: e.number()
}).readonly(), r = e.array(n).readonly(), i = e.array(n).readonly(), c = e.object({
  creatives: e.int().nonnegative(),
  landings: e.int().nonnegative(),
  payments: e.int().nonnegative(),
  sites: e.int().nonnegative()
}).readonly();
export {
  r as AdvertiserBalancesSchema,
  n as BalanceItemSchema,
  c as ModerationCountsSchema,
  i as SspBalancesSchema
};
//# sourceMappingURL=schemas.js.map
